import { render, staticRenderFns } from "./configMassivePublish.vue?vue&type=template&id=3a771f38&scoped=true&"
import script from "./configMassivePublish.vue?vue&type=script&lang=js&"
export * from "./configMassivePublish.vue?vue&type=script&lang=js&"
import style0 from "./configMassivePublish.vue?vue&type=style&index=0&id=3a771f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a771f38",
  null
  
)

export default component.exports